/**
 * PrivacyPolicy screen styles
 */

import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  heading: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
  },
  // Shown above the policy body when reading a translation rather than the
  // authoritative English original.
  disclaimer: {
    fontSize: 13,
    fontStyle: 'italic',
    textAlign: 'center',
    marginHorizontal: 15,
    marginBottom: 12,
    opacity: 0.8,
  },
  subheading: {
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 5,
  },
  date: {
    marginTop: 20,
    marginBottom: 20,
  },
  bullets: {
    marginLeft: 15,
    marginTop: 5,
    marginBottom: 5,
  },
});

export default styles;
